import { darken } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((_theme) => ({
  root: {
    background: darken(_theme.palette.background.paper, 0.3),
    padding: '0 8px!important',
    justifyContent: 'space-between',
    '& *': { color: '#eee' },
    '& [class*=disabled]': { opacity: 0.2 },
  },
}));
